import React from 'react'
import PropTypes from 'prop-types'

import PinDigitInput from './PinDigitInput'

const PIN_DIGITS_COUNT = 4

export default class PinCodeInput extends React.Component {

  static propTypes = {
    disabled: PropTypes.bool,
    phoneNumber: PropTypes.string.isRequired,
    pinCode: PropTypes.number,
    onPinCodeChanged: PropTypes.func.isRequired,
    onEnterPressed: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.inputDigits = new Array(PIN_DIGITS_COUNT)
    this.state = {
      current: 0
    }
  }

  componentDidMount() {
    this.inputDigits[0].focus()
  }

  handleDigitChanged = (index, digit) => {
    const newState = Object.assign({}, this.state)
    if (index < PIN_DIGITS_COUNT - 1) {
      // Move to the next digit automatically
      newState.current = index + 1
    }
    this.setState(newState)
    const currentDigitValue = this.getDigit(index)
    this.props.onPinCodeChanged(this.props.pinCode + (digit - currentDigitValue) * Math.pow(10, PIN_DIGITS_COUNT - index - 1))
    this.inputDigits[newState.current].focus()
  }

  getDigit = index => {
    return Math.floor(this.props.pinCode / Math.pow(10, PIN_DIGITS_COUNT - index - 1) % 10)
  }

  render() {
    const inputs = new Array(PIN_DIGITS_COUNT)
    for (let j = 0; j < PIN_DIGITS_COUNT; j++) {
      inputs[j] = <PinDigitInput
        key={j}
        id={j}
        ref={digit => this.inputDigits[j] = digit}
        disabled={this.props.disabled}
        digit={this.getDigit(j)}
        onDigitChanged={digit => this.handleDigitChanged(j, digit)}
        onEnterPressed={this.props.onEnterPressed} />
    }
    return (
      <div style={styles.container}>
        <div style={styles.digitsContainer}>
          { inputs }
        </div>
        <div style={styles.pinText}>
          Your PIN was sent in a text message to 
        </div>
        <div style={styles.numberText}>
          { this.props.phoneNumber }
        </div>
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  digitsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
  },

  pinText: {
    textAlign: 'center',
    color: '#4a4a4a',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 300,
    marginTop: 6
  },

  numberText: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 300,
    marginTop: 3
  }

}



// WEBPACK FOOTER //
// ./src/login/PinCodeInput.js